<template>
    <div class="px-4 py-2">
        <h2>Visualização</h2>
        <b-card no-body>
            <b-tabs v-model="activeTab" card>
                <b-tab title="Parâmetros de entrada">
                    <input-parameters @open-visualization-tab="activeTab = 1">
                        <template #default="{ reservoirInfo }">
                            <slot
                                name="reservoir-info"
                                :reservoir-info="reservoirInfo"
                            />
                        </template>
                    </input-parameters>
                </b-tab>
                <b-tab title="Visualização 3D">
                    <visualization3-d />
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import Visualization3D from "./components/Visualization3D";
import InputParameters from "./components/InputParameters";

export default {
    name: "ViewVisualization",
    components: {
        InputParameters,
        Visualization3D
    },
    data() {
        return {
            activeTab: 0
        };
    }
};
</script>
